import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MenuComponent } from "./league-module/menu/menu.component";
import { AuthGuard } from "./auth.guard";
import { ExperimentComponent } from "./experiment/experiment.component";

export const routes: Routes = [
  { path: "", redirectTo: "landing", pathMatch: "full" },
  {
    path: "landing",
    loadChildren: "./login-module/landing/landing.module#LandingModule",
  },
  // {path: 'ex', component: ExperimentComponent},
  {
    path: "login",
    loadChildren: "./login-module/login/login.module#LoginModule",
  },
  {
    path: "blocked-user",
    loadChildren:
      "./login-module/blocked-user/blocked-user.module#BlockedUserModule",
  },
  {
    path: "blocked-user-help",
    loadChildren:
      "./login-module/blocked-user-help/blocked-user-help.module#BlockedUserHelpModule",
  },
  {
    path: "verify-otp",
    loadChildren: "./login-module/verify-otp/verify-otp.module#VerifyOtpModule",
  },
  {
    path: "forgot-password",
    loadChildren:
      "./login-module/forgot-password/forgot-password.module#ForgotPasswordModule",
  },
  {
    path: "teampreview/sharing",
    loadChildren:
      "./league-module/team-share-preview/team-share-preview.module#TeamSharePreviewModule",
  },
  {
    path: "reset-password",
    loadChildren:
      "./login-module/reset-password/reset-password.module#ResetPasswordModule",
  },
  {
    path: "quiz-pre-confirmation/:matchid/:lapseTime",
    loadChildren:
      "./quiz/quiz-pre-confirmation/quiz-pre-confirmation.module#QuizPreConfirmationModule",
  },
  {
    path: "quiz-question/:matchid/:languageType",
    loadChildren: "./quiz/question/question.module#QuestionModule",
  },
  {
    path: "real-questions/:matchid/:leagueid",
    loadChildren:
      "./quiz/real-questions/real-questions.module#RealQuestionsModule",
  },
  {
    path: "quiz-find-player/:matchid/:leagueid",
    loadChildren:
      "./quiz/real-find-player/real-find-player.module#RealFindPlayerModule",
  },
  {
    path: "quiz-download-app",
    loadChildren: "./quiz/real-contest/real-contest.module#RealContestModule",
  },
  {
    path: "quiz-over/:matchid",
    loadChildren: "./quiz/quiz-over/quiz-over.module#QuizOverModule",
  },
  {
    path: "support",
    loadChildren: "./more-module/support/support.module#SupportModule",
  },
  {
    path: "live-chat",
    loadChildren: "./more-module/live-chat/live-chat.module#LiveChatModule",
  },
  {
    path: "unutilized-withdrawal",
    loadChildren:
      "./more-module/unutilized-withdrawal/unutilized-withdrawal.module#UnutilizedWithdrawalModule",
  },
  {
    path: "account-verify",
    loadChildren:
      "./profile-module/account-verify/account-verify.module#AccountVerifyModule",
  },
  {
    path: "panno-verify",
    loadChildren:
      "./profile-module/pancard-verify/pancard-verify.module#PancardVerifyModule",
  },
  {
    path: "address-verify",
    loadChildren:
      "./profile-module/address-verification/address-verification.module#AddressVerificationModule",
  },
  {
    path: "address-info-detail",
    loadChildren:
      "./profile-module/address-info-detail/address-info-detail.module#AddressInfoDetailModule",
  },
  {
    path: "add-cash/:amount",
    loadChildren: "./profile-module/add-cash/add-cash.module#AddCashModule",
  },
  {
    path: "add-cash",
    loadChildren: "./profile-module/add-cash/add-cash.module#AddCashModule",
  },
  {
    path: "offers",
    loadChildren: "./profile-module/offers/offers.module#OffersModule",
  },
  {
    path: "scratch-card",
    loadChildren:
      "./profile-module/scratch-card/scratch-card.module#ScratchCardModule",
  },
  {
    path: "tds-certificate",
    loadChildren:
      "./profile-module/tds-certificate/tds-certificate.module#TdsCertificateModule",
  },
  {
    path: "payment/:amount/:id/:page",
    loadChildren: "./profile-module/payment/payment.module#PaymentModule",
  },
  {
    path: "withdrawal",
    canActivate: [AuthGuard],
    loadChildren:
      "./profile-module/withdrawal/withdrawal.module#WithdrawalModule",
  },
  {
    path: "withdrawal-detail/:id",
    canActivate: [AuthGuard],
    loadChildren:
      "./profile-module/withdrawal-detail/withdrawal-detail.module#WithdrawalDetailModule",
  },
  {
    path: "withdrawal-status",
    canActivate: [AuthGuard],
    loadChildren:
      "./profile-module/withdrawal-status/withdrawal-status.module#WithdrawalStatusModule",
  },
  {
    path: "recent-transactions",
    canActivate: [AuthGuard],
    loadChildren:
      "./profile-module/recent-transactions/recent-transactions.module#RecentTransactionsModule",
  },
  {
    path: "cash-bonus-history",
    loadChildren:
      "./profile-module/cash-bonus-history/cash-bonus-history.module#CashBonusHistoryModule",
  },
  {
    path: "update-password",
    loadChildren:
      "./profile-module/update-password/update-password.module#UpdatePasswordModule",
  },
  {
    path: "invite-code",
    loadChildren:
      "./league-module/invite-code/invite-code.module#InviteCodeModule",
  },
  {
    path: "invite-code/:invitecode",
    loadChildren:
      "./league-module/invite-code/invite-code.module#InviteCodeModule",
  },
  {
    path: "notification",
    loadChildren:
      "./more-module/notification/notification.module#NotificationModule",
  },
  {
    path: "change-language",
    loadChildren: "./more-module/language/language.module#LanguageModule",
  },
  {
    path: "poll-list",
    loadChildren: "./more-module/poll-list/poll-list.module#PollListModule",
  },
  {
    path: "favorite-team",
    loadChildren:
      "./profile-module/favourite-team/favourite-team.module#FavouriteTeamModule",
  },
  {
    path: "my-profile",
    loadChildren:
      "./profile-module/my-profile/my-profile.module#MyProfileModule",
  },
  {
    path: "series-rank",
    loadChildren:
      "./profile-module/series-rank/series-rank.module#SeriesRankModule",
  },
  {
    path: "edit-profile",
    loadChildren:
      "./profile-module/edit-profile/edit-profile.module#EditProfileModule",
  },
  {
    path: "refer-n-earn",
    loadChildren:
      "./profile-module/refer-earn/refer-earn.module#ReferEarnModule",
  },
  {
    path: "passes-and-coupons",
    loadChildren:
      "./profile-module/passes-and-coupons/passes-and-coupons.module#PassesAndCouponsModule",
  },
  {
    path: "coupon-info/:passId",
    loadChildren:
      "./profile-module/coupon-info/coupon-info.module#CouponInfoModule",
  },
  {
    path: "contact-list",
    loadChildren:
      "./profile-module/contact-list/contact-list.module#ContactListModule",
  },
  {
    path: "settings",
    loadChildren: "./profile-module/settings/settings.module#SettingsModule",
  },
  {
    path: "verify-account",
    loadChildren:
      "./profile-module/verify-account/verify-account.module#VerifyAccountModule",
  },
  {
    path: "player-info/:playerId/:matchType/:teamId/:name/:matchid/:leagueid",
    loadChildren:
      "./league-module/player-info-stats-preview/player-info-stats-preview.module#PlayerInfoStatsPreviewModule",
  },
  {
    path: "player-info/:playerId/:matchType/:matchid/:leagueid",
    loadChildren:
      "./league-module/player-info-stats-preview/player-info-stats-preview.module#PlayerInfoStatsPreviewModule",
  },
  {
    path: "feedback",
    loadChildren: "./more-module/feedback/feedback.module#FeedbackModule",
  },
  {
    path: "favourite-contest",
    loadChildren:
      "./more-module/favourite-contest/favourite-contest.module#FavouriteContestModule",
  },
  {
    path: "rank/:seriesId/:sportType",
    loadChildren: "./profile-module/rank/rank.module#RankModule",
  },
  {
    path: "menu",
    component: MenuComponent,
    children: [
      { path: "", redirectTo: "home", pathMatch: "full" },
      {
        path: "home",
        loadChildren: "./league-module/matches/matches.module#MatchesModule",
      },
      {
        path: "contest",
        loadChildren: "./league-module/contest/contest.module#ContestModule",
      },
      {
        path: "wallet",
        loadChildren: "./profile-module/wallet/wallet.module#WalletModule",
      },
      {
        path: "more",
        loadChildren: "./more-module/more/more.module#MoreModule",
      },
    ],
  },
  {
    path: "sports",
    loadChildren:
      "./league-module/count-down/count-down.module#CountDownModule",
  },
  {
    path: "more/:path",
    loadChildren: "./more-module/webview/webview.module#WebviewModule",
  },
  { path: "**", loadChildren: "./not-found/not-found.module#NotFoundModule" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: "reload",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
